import { render, staticRenderFns } from "./ListCustomers.vue?vue&type=template&id=4ce7de62&"
import script from "./ListCustomers.vue?vue&type=script&lang=js&"
export * from "./ListCustomers.vue?vue&type=script&lang=js&"
import style0 from "./ListCustomers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports